// extracted by mini-css-extract-plugin
export default {"header":"EditGeofenceHeader_header__-6AMI","header__title":"EditGeofenceHeader_header__title__IzHTw"};